<template>
  <Layout>
    <modal v-if="showModal"/>
    <div class="row">
      <div class="col-md-10 mx-auto">
        <h3>Tableau de bord</h3>
        <p v-if="user">{{ $t('navbar.dashboard.welcome_message', { username: user.name }) }}</p>
        <div class="row mt-3">
          <div class="col-md">
            <div class="card minimal documents"
              @click.prevent="$router.push({ path: '/documents' })">         
              <div class="row">
                <div class="col-4 text-center">
                  <i class="bx bx-file"></i>
                </div>
                <div class="col-8">
                  <h3 v-if="documentLoading">...</h3> 
                  <h3 v-else>{{documents_count}}</h3> 
                  <h5>{{$t("navbar.dashboard.card.documents") }}</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card minimal users"
              @click.prevent="$router.push({ path: '/tasks/pending' })">         
              <div class="row">
                <div class="col-4 text-center">
                  <i class="bx bx-task"></i>
                </div>
                <div class="col-8">
                  <h3 v-if="tasksLoading">...</h3>
                  <h3 v-else>{{ userTasks }}</h3>
                  <h5>{{ $t("menuitems.tasks.text") }}</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card minimal types">          
              <div class="row">
                <div class="col-4 text-center">
                  <i class="bx bx-archive"></i>
                </div>
                <div class="col-8">
                  <h3 v-if="storageLoading">...</h3>
                  <h3 v-else>{{ bytesToHuman(documentsSize) }}</h3>
                  <h5>{{ $t("navbar.dashboard.card.storage") }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
              <h4 class="card-title mb-12 mb-3">
                {{ $t('pages.logs.latest.title') }}
              </h4>
              <div class="row" v-if="fetchingLatestDocuments">
                <div class="col-md-12">
                  <b-skeleton animation="fade" class="mb-2" type="input" width="80%"></b-skeleton>
                  <b-skeleton animation="fade" class="mb-2" type="input" width="100%"></b-skeleton>
                  <b-skeleton animation="fade" class="mb-2" type="input" width="90%"></b-skeleton>
                </div>
              </div>
              <table class="table table-hover table-sm" v-else-if="latestDocuments.length > 0">
                <tbody>
                  <tr v-for="(document, index) in latestDocuments" 
                      :key="index" 
                      @click="preview(document, $event)"
                      class="recent-item"
                  >
                    <td class="text-primary">
                      <img class="mr-3" v-if="getExtension(document.name) === 'pdf'" width="40" src="../../../assets/icons/pdf.png" alt="">
                      <img class="mr-3" v-else-if="getExtension(document.name) === 'doc' || getExtension(document.name) === 'docx'" 
                            width="40" src="../../../assets/icons/word.svg" alt="">
                      <img class="mr-3" v-else-if="getExtension(document.name) === 'xls' || getExtension(document.name) === 'xlsx'" 
                            width="40" src="../../../assets/icons/excel.svg" alt="">
                      <img class="mr-3" v-else-if="getExtension(document.name) === 'ppt' || getExtension(document.name) === 'pptx'" 
                            width="40" src="../../../assets/icons/powerpoint.svg" alt="">
                      <img class="mr-3" v-else-if="getExtension(document.name) === 'mp3' || getExtension(document.name) === 'wav'" 
                            width="40" src="../../../assets/icons/audio.png" alt="">
                      <img class="mr-3" v-else-if="getExtension(document.name) === 'mp4' || getExtension(document.name) === 'mpeg'" 
                            width="40" src="../../../assets/icons/video.png" alt="">
                      <img class="mr-3" width="40" v-else src="../../../assets/icons/picture.png" alt="">
                      <span class="recent-item-name">{{ document.name }}</span>
                    </td>
                    <td class="">{{ document.document_type }}</td>
                    <td class="text-right ">{{ $d(new Date(document.date), 'short') }}</td>
                  </tr>
                </tbody>           
              </table>
              <div class="row mt-4" v-else>
                <div class="col-md-12">
                  <div class="jumbotron">
                    <h5 class="text-primary">{{ $t('navbar.dashboard.no_lastest_documents') }}</h5>
                    <p>{{ $t('navbar.dashboard.no_latest_documents_message') }}</p>
                  </div>
                  <button class="btn btn-primary" 
                          @click.prevent="$router.push({ path: '/documents' })">
                    {{ $t('navbar.dashboard.access_documents') }}
                  </button>
                </div>
              </div>
          </div>
        </div> 
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import managerHelper from "../../../components/manager/mixins/manager"
// import Emailsent from "@/components/widgets/emailsent";
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapActions } from "vuex";

import i18n from '@/i18n';
import { mapState } from 'vuex';
import workflowApi from '../../../api/workflowApi';

/**
 * Dashboard Component
 */
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    // Emailsent,
  },
  mixins: [managerHelper],
  data() {
    return {
      title: "navbar.header.header_title",
      user: JSON.parse(localStorage.getItem('user')),
      userLoading: true,
      userTasks: null,
      documentLoading: true,
      documentTypeLoading: true,
      storageLoading: true,
      tasksLoading: false,
      items: [
        {
          text: "menuitems.dashboards.text",
          href: "/",
        }
      ],
      loadingCounter: 0,
      usersCount: 0,
      documetstypes_count:0,
      documents_count:0,
      documentsSize:0,
      documentsList:{},
      logs:{},
      fileData: [],
      latestDocuments: [],
      fetchingLatestDocuments: false,
      filePath: "/"
    };
  },
  computed: {
    local() {
      return i18n.local
    },
    ...mapState({
      showModal: (state) => state.modal.showModal,
    }),
    selectedItem() {
      return this.$store.getters['selectedItems'][0];
    }
  },
  methods: {
    ...mapActions([
      "getCountUsers",
      "getCountTasks",
      "getDocumentTypescount",
      "getDocumentscount",
      "getDocumentsSize",
      "getListdocuments",
      "getListlogs",
      "permissionsUser", 
      "getLatestDocuments"
    ]),
    bytesToHuman(bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

      if (bytes === 0) return '0 Bytes';

      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);

      if (i === 0) return `${bytes} ${sizes[i]}`;

      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
    },
    truncateString(str) {
      if (str.length > 50) {
        return str.slice(0, 50) + "...";
      } else {
        return str;
      }
    },
    getExtension(fileName) {
      const parts = fileName.split(".");
      return parts[parts.length - 1];
    },
    preview(document, event) {
      this.selectItem('files', document.path, event);
      this.selectAction(document.path, document.extension);
    },
  },
  created() {
    this.isLoadingData = true;
    
    this.tasksLoading = true;
    workflowApi.countWaitingTasks()
      .then((response) => {
        this.userTasks = response.data.length;
        this.tasksLoading = false;
      })
      .catch(() => {
        this.tasksLoading = false;
      });
   
    this.getCountUsers().then(response => {
      this.usersCount = response.data.users_count;
      this.userLoading = false;
    }).catch(() => {
      this.userLoading = false;
    })
    
    this.getListdocuments().then(response => {
      this.documentsList = response.data;
      this.documentLoading = false;
    }).catch(() => {
      this.documentLoading = false;
    });
    
    this.getDocumentscount().then(response => {
      this.documents_count = response.data.documents_count;
      this.documentTypeLoading = false;
    }).catch(() => {
      this.documentTypeLoading = false;
    });

    this.getDocumentsSize().then(response => {
        this.documentsSize = response.data;
        this.storageLoading=false;
    }).catch(() => {
      this.storageLoading=false;
    });

    // fetching latest documents
    this.fetchingLatestDocuments = true;
    this.getLatestDocuments().then((response) => {
      this.latestDocuments = response.data;
      this.$store.commit(`left/setDirectoryContent`, { directories : [], files : this.latestDocuments});
      this.fetchingLatestDocuments = false;
    }).catch(() => {
      this.fetchingLatestDocuments = false;
    });
  },
};
</script>

<style lang="scss" scoped>
  .recent-item {
    cursor: pointer;
    &:hover{
      .recent-item-name {
        color:#5360d4;
        text-decoration: underline;
      }
    }
  }
  .card {
    h3 {
      color: white;
      margin-top: 4vh;
    }
    h5 {
      color: white;
    }
    .bx{
      margin-top: 5vh;
      font-size: 40px;
      margin-left: 20px;
      color: white;
    }
  }
  .minimal {
    height: 16vh;
    cursor: pointer;
  }
  .documents {
    background-color: #6368EA;
    transition: .3s;
    &:hover{
      background-color: #5357d4;
    }
  }
  .users {
    background-color: #FB8095;
    transition: .3s;
    &:hover{
      background-color: #e46a7e;
    }
  }
  .types {
    background-color: #FF9557;
    transition: .3s;
    &:hover{
      background-color: #eb8143;
    }
  }
  .storage {
    background-color: #07A1DD;
    transition: .3s;
    &:hover{
      background-color: #038bc0;
    }
  }
</style>
